<ng-container *transloco="let t">
  <div
    class="form-group question-container-inner mt-5"
    [formGroup]="questionForm()"
  >
    @if (sortedNextReports?.length > 0) {
      <ng-container
        *ngTemplateOutlet="
          datesTemplate;
          context: {
            readOnlyDateFirst: currentReportDateReadonly(),
            readOnlyDateSecond: newReportDateReadonly(),
            newDateControl: newReportDate,
            headlineLabel: reportTypeHeadline(),
            nextReportHeadline: t('begaran_date_next_report'),
            firstLabel: t('begaran_current_report_date'),
            secondLabel: t('begaran_new_report_date'),
            errorMessage: errorMessageReportDate(),
            minDate: newReportDateMin,
            foregaendeRapportUnderBehandling: foregaendeRapportUnderBehandling,
          }
        "
      ></ng-container>
    } @else {
      <p class="report-heading">{{ t('begaran_all_reports_sent_in') }}</p>
      <lib-icon
        size="large"
        class="success mt-2 mb-5"
        name="check-circle"
      ></lib-icon>
    }
    <ng-container
      *ngTemplateOutlet="
        datesTemplate;
        context: {
          readOnlyDateFirst: currentProjectEndDateReadonly(),
          readOnlyDateSecond: newProjectEndDateReadonly(),
          newDateControl: newProjectEndDate,
          headlineLabel: t('begaran_project_end_date'),
          firstLabel: t('begaran_current_end_date'),
          secondLabel: t('begaran_new_end_date'),
          errorMessage: errorMessageEndDate(),
          minDate: newProjectEndDateMin,
          foregaendeRapportUnderBehandling: false,
        }
      "
    ></ng-container>
  </div>

  <!-- Templates -->
  <ng-template
    #datesTemplate
    let-readOnlyDateFirst="readOnlyDateFirst"
    let-readOnlyDateSecond="readOnlyDateSecond"
    let-newDateControl="newDateControl"
    let-headlineLabel="headlineLabel"
    let-nextReportHeadline="nextReportHeadline"
    let-firstLabel="firstLabel"
    let-secondLabel="secondLabel"
    let-errorMessage="errorMessage"
    let-minDate="minDate"
    let-foregaendeRapportUnderBehandling="foregaendeRapportUnderBehandling"
  >
    @if (nextReportHeadline) {
      <p class="report-heading">{{ nextReportHeadline }}</p>
    }
    <lib-input-container
      [required]="true"
      [for]="labelPrefix() + question().id"
      [inputType]="InputType.Date"
      width="full"
      [label]="headlineLabel"
      [labelHeader]="true"
      [fileOrEndDateDescription]="
        !nextReportHeadline
          ? (question().translations?.list['description']
            | translate: activeLangSignal() : question().structure.description)
          : ''
      "
    >
      @if (!foregaendeRapportUnderBehandling) {
        <div class="d-md-flex justify-content-between">
          <lib-input-container
            [label]="firstLabel"
            [required]="true"
            [inputType]="InputType.Date"
            width="full"
            class="w-100"
          >
            <ng-container
              *ngTemplateOutlet="
                readonlyTemplate;
                context: {
                  date: readOnlyDateFirst,
                }
              "
            ></ng-container>
          </lib-input-container>
          <lib-input-container
            [label]="secondLabel"
            [errorText]="errorMessage"
            [for]="
              labelPrefix() +
              question().id +
              (nextReportHeadline ? '-reportDate' : '-endDate')
            "
            [inputType]="InputType.Date"
            width="full"
            class="w-100 ms-4"
          >
            @if (!readOnlySignal()) {
              <lib-dot-indicator
                type="datepicker"
                [isVisible]="showChanges() && formHasChanges(newDateControl)"
              />
              <lib-datepicker
                [formControl]="newDateControl"
                [minDate]="minDate"
                [id]="
                  labelPrefix() +
                  question().id +
                  (nextReportHeadline ? '-reportDate' : '-endDate')
                "
                [isInvalid]="!!errorMessage"
                [label]=""
              ></lib-datepicker>
            } @else {
              <ng-container
                *ngTemplateOutlet="
                  readonlyTemplate;
                  context: {
                    date: readOnlyDateSecond,
                  }
                "
              ></ng-container>
            }
          </lib-input-container>
        </div>
      } @else {
        <p>
          {{ t('last_report_not_assessed') }}
        </p>
      }
    </lib-input-container>
  </ng-template>

  <ng-template #readonlyTemplate let-date="date">
    <div class="readonly">
      {{ date }}
      <div class="icon-btn open-calendar-btn" [aria-hidden]="true">
        <lib-icon name="calendar" size="small"></lib-icon>
      </div>
    </div>
  </ng-template>
</ng-container>
